import { Routes } from '@angular/router';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { WASenderSetupComponent } from './wasender-setup.component';
import { WASenderChatComponent } from './wasender-chat.component';

export const wasenderRoutes: Routes = [
  {
    path: 'wasender',
    pathMatch: 'full',
    redirectTo: 'wasender/chat'
  },
  {
    path: 'wasender/setup',
    component: WASenderSetupComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      enterpriseModules: ['WASENDER'],
      enterpriseFeatureLabel: 'WhatsApp Messaging',
      permission: app_permissions.wasender.setup.view
    }
  },
  {
    path: 'wasender/chat',
    component: WASenderChatComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      enterpriseModules: ['WASENDER'],
      enterpriseFeatureLabel: 'WhatsApp Messaging',
      permission: app_permissions.wasender.chat.view
    }
  }
];
